import { allBlockchainCoin } from '@/assets/static/currency-list'

export default {
  activeBlockchain: allBlockchainCoin,
  riskFilter: null,
  rangeFilter: {
    from: null,
    to: null,
  },
}
